
document.addEventListener('DOMContentLoaded', () => {
  const articlesContainer = document.querySelector('#articles-container');
  const paginationContainer = document.querySelector('#pagination-container');
  const archiveLinks = document.querySelectorAll('.archive-link');
  const articles = Array.from(articlesContainer.children);
  const articlesPerPage = 5;
  let currentPage = 1;
  let filteredArticles = [...articles];

  function renderArticles() {
    articles.forEach(article => article.style.display = 'none');
    const start = (currentPage - 1) * articlesPerPage;
    const end = start + articlesPerPage;
    filteredArticles.slice(start, end).forEach(article => {
      article.style.display = 'block';
    });
    renderPagination();
  }

  function renderPagination() {
    paginationContainer.innerHTML = '';
    const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
    if (totalPages <= 1) return;

    const createButton = (page, text, active = false) => {
      const button = document.createElement('a');
      button.textContent = text;
      button.classList.add('pagination-button');
      button.setAttribute('href',"#articles-container");
      if (active){
        button.classList.add('active');
      } 
      button.addEventListener('click', () => {
        const scrollY = window.scrollY;
        currentPage = page;
        renderArticles();
        window.scrollTo(0, scrollY);
      });
      return button;
    };

    // Previous Button 
    if (currentPage > 1) {
      const prevButton = createButton(currentPage - 1, 'Prev');
      paginationContainer.appendChild(prevButton);
    }

    // Page Numbers with Ellipses
    const pageRange = 2;
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - pageRange && i <= currentPage + pageRange)) {
        const pageButton = createButton(i, i, i === currentPage);
        paginationContainer.appendChild(pageButton);
      } else if (
        (i === currentPage - pageRange - 1) ||
        (i === currentPage + pageRange + 1)
      ) {
        const ellipsis = document.createElement('span');
        ellipsis.textContent = '...';
        ellipsis.classList.add('ellipsis');
        paginationContainer.appendChild(ellipsis);
      }
    }


    if (currentPage < totalPages) {
      const nextButton = createButton(currentPage + 1, 'Next');
      paginationContainer.appendChild(nextButton);
    }
  }

  function filterArticlesByDate(monthYear) {
    filteredArticles = articles.filter(article => {
      return article.getAttribute('data-monthyear') === monthYear;
    });
    currentPage = 1;
    renderArticles();
  }

  function showAllArticles() {
    filteredArticles = [...articles];
    currentPage = 1;
    renderArticles();
  }

  // Show all articles by default
  showAllArticles();


  archiveLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const monthYear = link.getAttribute('data-monthyear');
      filterArticlesByDate(monthYear);
    });
  });

  // --------------- New Code for Mobile Selects --------------- //
  const recentPostsSelect = document.querySelector('#recent-posts-select');
  const archiveSelect = document.querySelector('#archive-select');


  function populateRecentPostsSelect() {
    const recentBlogs = JSON.parse(localStorage.getItem("recentlyBlogs")) || [];
    recentBlogs.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.url;
      option.textContent = item.title;
      recentPostsSelect.appendChild(option);
    });
  }

  function populateArchiveSelect() {
    archiveLinks.forEach(link => {
      const option = document.createElement('option');
      option.value = link.getAttribute('data-monthyear');
      option.textContent = link.textContent;
      archiveSelect.appendChild(option);
    });
  }

  recentPostsSelect.addEventListener('change', (e) => {
    const selectedUrl = e.target.value;
    if (selectedUrl) {
      window.location.href = selectedUrl;
    }
  });

  archiveSelect.addEventListener('change', (e) => {
    const monthYear = e.target.value;
    if (monthYear) {
      filterArticlesByDate(monthYear);
    } else {
      showAllArticles();
    }
  });


  populateArchiveSelect();


  const recentPostsSelectArticle = document.querySelector('#recent-select-article');
  const archiveSelectArticle = document.querySelector('#archive-select-article');

  function populateRecentSelectArticle() {
    if (!recentPostsSelectArticle) return;
    const recentBlogs = JSON.parse(localStorage.getItem("recentlyBlogs")) || [];
    recentBlogs.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.url;
      option.textContent = item.title;
      recentPostsSelectArticle.appendChild(option);
    });
  }


  recentPostsSelectArticle.addEventListener('change', (e) => {
    const selectedUrl = e.target.value;
    if (selectedUrl) {
      window.location.href = selectedUrl;
    }
  });


  archiveSelectArticle.addEventListener('change', (e) => {
    const monthYear = e.target.value;
    if (monthYear) {
      filterArticlesByDate(monthYear);
    } else {
      showAllArticles();
    }
  });

  populateRecentSelectArticle();

});

document.addEventListener('DOMContentLoaded', () => {

  const recentPostsSelectArticle = document.querySelector('#recent-select-article');
  function handleRecentSelect(e) {
    const selectedUrl = e.target.value;
    if (selectedUrl) {
      window.location.href = selectedUrl;
    }
  }

  if (recentPostsSelectArticle) {
    recentPostsSelectArticle.addEventListener('change', handleRecentSelect);
    recentPostsSelectArticle.addEventListener('input', handleRecentSelect);
  }
});